import { Action } from '@ngrx/store';
import { DealVersion } from '../../types/deal.types';
import { MonitorCardTypes } from '../../types/monitor.types';
import { ColumnSortModel } from '../../grid/types/sorting.types';
import { MonitorGridColumnName } from '../../grid/types/column.types';

export enum MonitorActionTypes {
  LoadMonitor = '[Monitor] Load',
  LoadMonitorSuccess = '[Monitor] Load Success',
  LoadMonitorFail = '[Monitor] Load Fail',
  RemoveMonitorDeals = '[Monitor] Remove Unfollowed Deals',
  TaintMonitor = '[Monitor] Taint',
  MonitorIsActive = '[Monitor] Is Active',
  MonitorCardToggle = '[Monitor] Card Toggle',
  MonitorSetCardSortModel = '[Monitor] Set Card Sort Model',
  SaveMonitorDealScore = '[Monitor] Save Monitor Deal Score',
  SaveMonitorDealScoreSuccess = '[Monitor] Save Monitor Deal Score Success',
  SaveMonitorDealScoreFail = '[Monitor] Save Monitor Deal Score Fail',
  SaveMonitorDealOwnership = '[Monitor] Save Monitor Deal Ownership',
  SaveMonitorDealOwnershipSuccess = '[Monitor] Save Monitor Deal Ownership Success',
  SaveMonitorDealOwnershipFail = '[Monitor] Save Monitor Deal Ownership Fail',
  SaveMonitorDealStatus = '[Monitor] Save Monitor Deal Status',
  SaveMonitorDealStatusSuccess = '[Monitor] Save Monitor Deal Status Success',
  SaveMonitorDealStatusFail = '[Monitor] Save Monitor Deal Status Fail',
  SaveMonitorDealRating = '[Monitor] Save Monitor Deal Rating',
  SaveMonitorDealRatingSuccess = '[Monitor] Save Monitor Deal Rating Success',
  SaveMonitorDealRatingFail = '[Monitor] Save Monitor Deal Rating Fail'
}

export class LoadMonitor implements Action {
  public readonly type = MonitorActionTypes.LoadMonitor;

  constructor(public payload: boolean = true) {}
}

export class LoadMonitorSuccess implements Action {
  public readonly type = MonitorActionTypes.LoadMonitorSuccess;

  constructor(public payload: { data: DealVersion[] }) {}
}

export class LoadMonitorFail implements Action {
  public readonly type = MonitorActionTypes.LoadMonitorFail;

  constructor(public payload: string) {}
}

export class RemoveMonitorDeals implements Action {
  public readonly type = MonitorActionTypes.RemoveMonitorDeals;

  constructor(public payload: string[]) {}
}

export class TaintMonitor implements Action {
  public readonly type = MonitorActionTypes.TaintMonitor;
}

export class MonitorIsActive implements Action {
  public readonly type = MonitorActionTypes.MonitorIsActive;

  constructor(public payload: boolean) {}
}

export class MonitorCardToggle implements Action {
  public readonly type = MonitorActionTypes.MonitorCardToggle;

  constructor(public payload: MonitorCardTypes) {}
}

export class MonitorSetCardSortModel implements Action {
  public readonly type = MonitorActionTypes.MonitorSetCardSortModel;
  constructor(
    public payload: {
      key: MonitorCardTypes;
      sortModel: ColumnSortModel<MonitorGridColumnName>[];
    }
  ) {}
}

export class SaveMonitorDealScore implements Action {
  public readonly type = MonitorActionTypes.SaveMonitorDealScore;

  constructor(public payload: { dealId: string; score: string }) {}
}

export class SaveMonitorDealScoreSuccess implements Action {
  public readonly type = MonitorActionTypes.SaveMonitorDealScoreSuccess;
  constructor(public payload: { dealId: string; score: string }) {}
}

export class SaveMonitorDealScoreFail implements Action {
  public readonly type = MonitorActionTypes.SaveMonitorDealScoreFail;

  constructor(
    public payload: { dealId: string; score: string; error: string }
  ) {}
}

export class SaveMonitorDealRating implements Action {
  public readonly type = MonitorActionTypes.SaveMonitorDealRating;

  constructor(public payload: { dealId: string; rating: string }) {}
}

export class SaveMonitorDealRatingSuccess implements Action {
  public readonly type = MonitorActionTypes.SaveMonitorDealRatingSuccess;
  constructor(public payload: { dealId: string; rating: string }) {}
}

export class SaveMonitorDealRatingFail implements Action {
  public readonly type = MonitorActionTypes.SaveMonitorDealRatingFail;

  constructor(
    public payload: { dealId: string; rating: string; error: string }
  ) {}
}

export class SaveMonitorDealOwnership implements Action {
  public readonly type = MonitorActionTypes.SaveMonitorDealOwnership;

  constructor(public payload: { dealId: string; ownership: boolean }) {}
}

export class SaveMonitorDealOwnershipSuccess implements Action {
  public readonly type = MonitorActionTypes.SaveMonitorDealOwnershipSuccess;
  constructor(public payload: { dealId: string; ownership: boolean }) {}
}

export class SaveMonitorDealOwnershipFail implements Action {
  public readonly type = MonitorActionTypes.SaveMonitorDealOwnershipFail;

  constructor(
    public payload: { dealId: string; ownership: boolean; error: string }
  ) {}
}

export class SaveMonitorDealStatus implements Action {
  public readonly type = MonitorActionTypes.SaveMonitorDealStatus;

  constructor(public payload: { dealId: string; status: string }) {}
}

export class SaveMonitorDealStatusSuccess implements Action {
  public readonly type = MonitorActionTypes.SaveMonitorDealStatusSuccess;
  constructor(public payload: { dealId: string; status: string }) {}
}

export class SaveMonitorDealStatusFail implements Action {
  public readonly type = MonitorActionTypes.SaveMonitorDealStatusFail;

  constructor(
    public payload: { dealId: string; status: string; error: string }
  ) {}
}

export type MonitorActionUnion =
  | LoadMonitor
  | LoadMonitorSuccess
  | LoadMonitorFail
  | RemoveMonitorDeals
  | TaintMonitor
  | MonitorIsActive
  | MonitorCardToggle
  | MonitorSetCardSortModel
  | SaveMonitorDealScore
  | SaveMonitorDealScoreSuccess
  | SaveMonitorDealScoreFail
  | SaveMonitorDealRating
  | SaveMonitorDealRatingSuccess
  | SaveMonitorDealRatingFail
  | SaveMonitorDealOwnership
  | SaveMonitorDealOwnershipSuccess
  | SaveMonitorDealOwnershipFail
  | SaveMonitorDealStatus
  | SaveMonitorDealStatusSuccess
  | SaveMonitorDealStatusFail;
